export const getDefaultStringInsteadOfNull = (text: string | null) => {
  if (text == null || text.trim() === '') return '-'
  return text
}
